import { render, staticRenderFns } from "./CreateShortcutPopUp.vue?vue&type=template&id=2e8b8f2a&scoped=true&"
import script from "./CreateShortcutPopUp.vue?vue&type=script&lang=js&"
export * from "./CreateShortcutPopUp.vue?vue&type=script&lang=js&"
import style0 from "./CreateShortcutPopUp.vue?vue&type=style&index=0&id=2e8b8f2a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e8b8f2a",
  null
  
)

export default component.exports